const React = require("react");

module.exports = (props) => (
  <svg {...props} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M43 0H16V40.5V41.7391L16.0287 41.7815C16.4855 51.9537 22.3422 60 29.5 60C36.6606 60 42.519 51.9474 42.9718 41.7696L43 41.7391V40.5V0Z" fill="white"/>
    <rect x="20" y="4" width="19" height="34" fill="#3e4044"/>
  </svg>
)
